/**
 * 获取环境变量的辅助函数
 * 统一使用 VUE_APP_ 前缀（Vue CLI标准）
 * @param {string} key - 环境变量键名
 * @param {string} defaultValue - 默认值
 * @returns {string}
 */
const getEnvVar = (key, defaultValue = '') => {
    if (typeof process !== 'undefined' && process.env) {
        // 统一使用 VUE_APP_ 前缀
        const envKey = `VUE_APP_${key}`;
        return process.env[envKey] || defaultValue;
    }
    return defaultValue;
};

/**
 * 获取API基础URL
 * @returns {string}
 */
const getBaseUrl = () => {
    return getEnvVar('BASE_URL', 'https://api.dbgm-hk.com');
};

/**
 * 获取WebSocket URL
 * @returns {string}
 */
const getWsUrl = () => {
    return getEnvVar('WS_URL', 'wss://ws.dbgm-hk.com');
};

/**
 * 获取OSS存储URL
 * @returns {string}
 */
const getOssUrl = () => {
    return getEnvVar('OSS_URL', '');
};

export default {
    // API基础URL
    BASE_URL: getBaseUrl(),
    // WebSocket地址
    BASE_WSS: getWsUrl(),
    BASE_IO: getWsUrl(), // 使用相同的WebSocket地址
    // OSS存储地址（用于文件上传）
    OSS_URL: getOssUrl(),
    // 环境标识
    ENV: getEnvVar('ENV', 'production'),
    // 应用标题
    TITLE: getEnvVar('TITLE', 'DBG Markets'),
    // 基础路径
    BASE: getEnvVar('BASE', '/'),
    // Token前缀
    TOKEN_PREFIX: getEnvVar('TOKEN_PREFIX', 'token'),
    // 代理前缀
    PROXY_PREFIX: getEnvVar('PROXY_PREFIX', '/prod'),
    // 是否开启代理
    OPEN_PROXY: getEnvVar('OPEN_PROXY', 'false') === 'true',
    // 默认语言
    default_lang: getEnvVar('DEFAULT_LANG', 'en-US'),
    // Google OAuth客户端ID
    GOOGLE_CLIENT_ID: getEnvVar('GOOGLE_CLIENT_ID', ''),
    // API超时时间(毫秒)
    API_TIMEOUT: parseInt(getEnvVar('API_TIMEOUT', '15000'), 10),
    // 客户端设备类型(2=PC端)
    CLIENT_DEVICE: parseInt(getEnvVar('CLIENT_DEVICE', '2'), 10),
    // WebSocket重连延迟(毫秒)
    WS_RECONNECT_DELAY: parseInt(getEnvVar('WS_RECONNECT_DELAY', '3000'), 10),
    // 是否开启调试模式
    DEBUG: getEnvVar('DEBUG', 'false') === 'true',
}
